import {ModalWithNewForm, Select} from '~/components'
import {Input} from '@eitje/web_components'
import {Admin} from '@eitje/api'
import {goBack} from '~/routing/actions'

const ROLES = [
	{id: 'admin', t: 'roles.admin'},
	{id: 'moderator', t: 'roles.moderator'},
]

export const NewAdmin = () => {
	return (
		<ModalWithNewForm
			name="create_admin"
			onSubmit={params => Admin.create(params)}
			afterSubmit={goBack}
			width={348}
			modalProps={{
				okButtonProps: {
					t: 'common.save',
				},
			}}
		>
			<Input field="name" required />
			<Input field="email" required />
			<Select field="role" items={ROLES} required />
			<Input field="password" required secure />
		</ModalWithNewForm>
	)
}
